import Quill from 'quill';

export const calculateCharacters = (quill: Quill, options: any = {}): number => {
  if (!quill) return 0;
  const length = quill.getLength();
  return length - 1;
};
export const preserveHtmlSpaces = (html: string): string => {
  if (!html) return html;

  return html
    .replace(/(^|>)([ \u3000]+)/gm, (_, p1, p2) => {
      const encoded = p2
        .split('')
        .map((ch: string) => (ch === ' ' ? '&nbsp;' : '__FULLWIDTH_SPACE__'))
        .join('');
      return p1 + encoded;
    })
    .replace(/( {2,})/g, (match) => {
      return ' ' + '&nbsp;'.repeat(match.length - 1);
    })
    .replace(/\u3000+/g, (match) =>
      match
        .split('')
        .map(() => '__FULLWIDTH_SPACE__')
        .join('')
    );
};

export const convertHtmlToDelta = (quill: Quill, html: string) => {
  if (!quill) return;
  // Replace sequences spaces with non-breaking spaces to force browser render each space individually
  const htmlCustomSpace = preserveHtmlSpaces(html);

  const flatDelta = quill.clipboard.convert({ html: htmlCustomSpace });
  return flatDelta.map((item: any) => ({
    ...item,
    insert: typeof item.insert === 'string' ? item.insert.replaceAll('__FULLWIDTH_SPACE__', '\u3000') : item.insert
  }));
};
